import { render, staticRenderFns } from "./Deeds.vue?vue&type=template&id=2c7866c4"
import script from "./Deeds.vue?vue&type=script&lang=ts"
export * from "./Deeds.vue?vue&type=script&lang=ts"
import style0 from "./Deeds.vue?vue&type=style&index=0&id=2c7866c4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports